import './SurveyQuizBarLayout.css'
import { isWindows } from '../../../../utils/isWindows';

const FormIndicatorLayout = (props) => {
  const {type} = props.question

  // number of steps (segments)
  const steps = 6;

  // i=2 is the disqualified box
  const currentIndex = props.currentSurveyQuestionI >= 2 ? (props.currentSurveyQuestionI - 1) : props.currentSurveyQuestionI
  
  // current is 0-based index of the active step
  const current = Math.max(0, Math.min(steps - 1, currentIndex || 0));

  const prevPct = (current / steps) * 96;           // left edge of current segment
  const currPct = ((current + 1) / steps) * 96;     // right edge of current segment
  const laneWidth = currPct - (prevPct + 2);    

  return (
    <div className="form-indicator mx-auto surveyQuizBar">
      {type == "QuizSurveyComplete" ? 
        <div className="bar-frame">
          <div className="bar-track">
             <span className={`bar-slice done w-100 complete`}></span>
             <div className="bar-label-lane w-100">
               <span className="bar-label">COMPLETE</span>
             </div>
          </div>
        </div>
      : 
      <div className="bar-frame">
        {/* base track */}
        <div className="bar-track" />

        {/* layered slices */}
        {Array.from({ length: steps }).map((_, i) => {
          const pct = ((i + 1) / steps) * 96; // cumulative width for slice i
          const done = i <= current;
          const isCurrent = i === current;
          
          return (
            <span
              key={i}
              className={`bar-slice ${done ? 'done' : ''} ${i === steps - 1 ? 'last' : ''}`}
              style={{ width: `${pct}%`, zIndex: steps - i }}
            >
            </span>
          );
        })}

        <div
          className="bar-label-lane"
          style={{ left: `${prevPct}%`, width: `${laneWidth}%` }}
        >
          <span className={`bar-label ${isWindows() ? "windowsTopSpace" : ""}`}>{`Q${current + 1}`}</span>
        </div>
      </div>}
    </div>
  );
};

export default FormIndicatorLayout;
